import React, { useState } from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';
import InputContainer from './InputContainer';
import InputMessage from './InputMessage';
import InputLabel from './InputLabel';

type ITextArea = {
	id: string;
	testId: string;
	label: string;
	placeholder: string;
	tabIndex: number;
	hookRegister: UseFormRegisterReturn;
	fieldError: FieldError | undefined;
	limit: number;
	clearErrors: (type: string) => void;
	value: string;
	hint?: string;
};

const TextArea = (props: ITextArea) => {
	const { id, testId, label, placeholder, tabIndex, hookRegister, fieldError, hint, limit, value, clearErrors } =
		props;
	const [content, setContent] = useState(value.slice(0, limit));

	const characterCounter = React.useCallback(
		(text: any) => {
			setContent(text.slice(0, limit));
			if (text < limit || text !== '') {
				clearErrors(id);
			}
		},
		[limit, clearErrors, id]
	);

	return (
		<InputContainer>
			<InputLabel inputId={id} inputTestId={testId} label={label} />
			<textarea
				className={`${fieldError ? 'input-error' : 'input-valid'}`}
				data-testid={testId}
				placeholder={placeholder}
				value={content}
				tabIndex={tabIndex}
				style={{
					padding: '17px 23px',
					minHeight: '200px',
					maxHeight: '400px',
				}}
				{...hookRegister}
				onChange={(event) => {
					characterCounter(event.target.value);
					hookRegister.onChange(event);
				}}
			/>
			{fieldError || limit > 0 ? (
				<InputMessage
					inputTestId={testId}
					fieldError={fieldError}
					inputHint={hint}
					contentLength={content.length}
					limit={limit}
				/>
			) : null}
		</InputContainer>
	);
};

export default TextArea;
